import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Nav } from "@/components/petraits/Nav";
import { Hero } from "@/components/petraits/Hero";
import { Marquee } from "@/components/petraits/Marquee";
import { Method } from "@/components/petraits/Method";
import { Gallery } from "@/components/petraits/Gallery";
import { Process } from "@/components/petraits/Process";
import { Pricing } from "@/components/petraits/Pricing";
import { Testimonials } from "@/components/petraits/Testimonials";
import { ConsultForm } from "@/components/petraits/ConsultForm";
import { Footer } from "@/components/petraits/Footer";
import { Studio } from "@/components/petraits/Studio";

const Landing = () => {
  const [selectedSize, setSelectedSize] = useState("undecided");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Method />
        <Gallery />
        <Process />
        <Pricing onSelect={setSelectedSize} />
        <Testimonials />
        <ConsultForm selectedSize={selectedSize} />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App bg-[#0C0A09] text-[#FAF6F0] font-sans">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/studio" element={<Studio />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-center" richColors />
    </div>
  );
}

export default App;
